import React from 'react';
import PropTypes from 'prop-types';
import Empty from 'constants/empty';
import {
    Container, Flex, Grid, Text, Divider, Box
} from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import AccountNav from 'components/RichProfile/MyAccount/AccountLayout/AccountNav';
import { site } from 'style/config';

function AccountLayout({
    page, title, children, beforeTitle, customCss = Empty.Object
}) {
    return (
        <Container
            paddingY={[5, 7]}
            hasLegacyWidth={true}
        >
            <Grid
                columns={[null, `${site.ACCOUNT_SETTINGS_NAV_WIDTH}px 1fr`]}
                gap={[5, null, 7]}
            >
                <Box
                    is='main'
                    css={customCss.main}
                >
                    {beforeTitle}
                    {title && (
                        <>
                            <Text
                                is='h1'
                                fontSize={['xl', null, '2xl']}
                                fontFamily='serif'
                                lineHeight='tight'
                                children={title}
                            />
                            <Divider
                                marginTop={3}
                                height={2}
                                color='black'
                            />
                        </>
                    )}
                    {children}
                </Box>
                <Divider
                    display={[null, 'none']}
                    marginX='-container'
                    thick={true}
                />
                <Flex
                    flexDirection='column'
                    borderRightWidth={[null, 1]}
                    borderColor='midGray'
                    paddingRight={[null, 4]}
                    order={[null, -1]}
                >
                    <AccountNav page={page} />
                </Flex>
            </Grid>
        </Container>
    );
}

AccountLayout.propTypes = {
    page: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    beforeTitle: PropTypes.node,
    customCss: PropTypes.object
};

export default wrapFunctionalComponent(AccountLayout, 'AccountLayout');
